import React from 'react';
import { normalizeName } from './cardFilter';
import styles from './highlightText.module.css';

export const highlightText = (searchString: string, option: string) => {
  if (!searchString) return option;

  const searchTerms = normalizeName(searchString).split(' ');
  let remainingOption = option;
  const optionChars = [];

  searchTerms.forEach((searchTerm) => {
    const startingIndex = normalizeName(remainingOption)
      .toLowerCase()
      .indexOf(searchTerm);
    const termLength = searchTerm.length;
    let i = 0;

    while (i < startingIndex + termLength) {
      const currentChar = remainingOption[0];
      if (i < startingIndex) {
        optionChars.push(currentChar);
      } else {
        optionChars.push(
          <span className={styles.boldLetter} key={Math.random()}>
            {currentChar}
          </span>
        );
      }

      remainingOption = remainingOption.slice(1);
      i++;
    }
  });

  const remainingText = remainingOption.split('');
  return optionChars.concat(remainingText);
};
